import Head from "next/head";
import React, { FC } from "react";
import { PreviewNote } from "./elements/PreviewNotice";
import { usePreview } from "./hooks";

export * from "./contexts";
export * from "./hooks";
export * from "./hocs";

export const Preview: FC = () => {
    const { preview } = usePreview();
    return preview ? (
        <>
            <Head>
                <meta name="robots" content="noindex,nofollow" />
            </Head>
            <PreviewNote />
        </>
    ) : null;
};
